<template>
    <q-table
        ref="table"
        :data="participants"
        :columns="columns"
        :filter="filter"
        row-key="id"
        :pagination.sync="pagination"
        @request="requestParticipants"
        :loading="loading"
        :no-data-label="$t('no_data_avaliable')"
        :no-results-label="$t('no_results_found')"
        :loading-label="$t('loading_data')"
        :rows-per-page-label="$t('items_per_page')"
        :rows-per-page-options="[5,10,50,100]"
        binary-state-sort
        class="q-mt-lg"
        >

        <template slot="top" slot-scope="props" :props="props">
            <q-search v-model="filter" icon="far fa-search" :placeholder="$t('search')" :debounce="500" />

            <div class="col" />
            <q-btn color="secondary q-mr-md" icon="fas fa-download" :label="$t('certified_report')" @click="downloadCertificateReport()" />
            <q-btn color="secondary" icon="fas fa-download" :label="$t('chat_report')" @click="downloadChatReport()" />
        </template>

        <q-tr slot="header" slot-scope="props" :props="props">
            <q-th v-for="col in props.cols" :key="col.name" :props="props">
                {{ $t(col.label) }}
            </q-th>
        </q-tr>

        <template slot="body" slot-scope="props">
            <q-tr :props="props">
                <q-td key="user_full_name" :props="props">
                    {{ props.row.user_full_name }}
                </q-td>

                <q-td key="user_email" :props="props">
                    {{ props.row.user_email }}
                </q-td>

                <q-td key="user_profile" :props="props">
                    {{ props.row.user_profile }}
                </q-td>

                <q-td key="result_date" :props="props">
                    {{ fDate(props.row.result_date) }}
                </q-td>

                <q-td key="percent" :props="props">
                    {{ props.row.percent ? `${props.row.percent.toFixed()}%` : '' }}
                </q-td>

                <q-td key="branches" :props="props">
                    <q-btn color="primary" text-color="white" :label="props.row.branches.length" no-ripple>
                        <q-tooltip>
                            <p v-if="props.row.branches.length > 0" class="tooltip q-mb-sm">
                                {{ $t('branches') }}:
                                <span v-for="(branche, index) in props.row.branches" :key="index">
                                    {{ branche }}
                                    <span v-if="(props.row.branches.length - 1) > index">, </span>
                                </span>
                            </p>
                        </q-tooltip>
                    </q-btn>
                </q-td>
            </q-tr>
        </template>
    </q-table>
</template>

<script>
import { mapGetters } from 'vuex'
import { date } from 'quasar'
const { formatDate } = date

export default {
    props: ['load', 'id'],

    data() {
        return {
            pagination: {
                page: 1,
                rowsNumber: 10,
                rowsPerPage: null,
                descending: false,
                sortBy: null
            },
            filter: '',
            columns: [
                {
                    name: 'user_full_name',
                    required: true,
                    label: 'name',
                    align: 'left',
                    field: 'user_full_name',
                    sortable: true,
                },
                {
                    name: 'user_email',
                    required: true,
                    label: 'email',
                    align: 'left',
                    field: 'user_email',
                    sortable: true,
                },
                {
                    name: 'user_profile',
                    required: true,
                    label: 'profile',
                    align: 'left',
                    field: 'user_profile',
                    sortable: false,
                },
                {
                    name: 'result_date',
                    required: true,
                    label: 'date',
                    align: 'left',
                    field: 'result_date',
                    sortable: false,
                },
                {
                    name: 'percent',
                    required: true,
                    label: 'percent',
                    align: 'left',
                    field: 'percent',
                    sortable: false,
                },
                {
                    name: 'branches',
                    required: true,
                    label: 'branches',
                    align: 'left',
                    field: 'branches',
                    sortable: false,
                },
            ],
            participants: [],
            loading: false
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            id_user_language_selected: 'common/id_user_language_selected',
            num_rows: 'datatable/num_rows'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        getMaxWidth() {
            if (this.$q.platform.is.mobile) return '100vw'
            else return '80vw'
        },

        getMinWidth() {
            if (!this.$q.platform.is.mobile) return '90vw'
        },
    },

    methods: {
        requestParticipants({ pagination }) {
            this.loading = true
            this.pagination = pagination

            let order = pagination.descending ? '-' : ''
            let order_by = pagination.sortBy ? order + pagination.sortBy : ''

            let data = {
                "page_size": this.pagination.rowsPerPage,
                "page": this.pagination.page,
                "ordering": order_by,
                "search": this.filter
            }

            this.savePagination()

            this.$axios.get(`/admin_webcasts/webcasts/${this.id}/webcast_user_results/?${this.$qs.stringify(data)}`, this.getHeader)
            .then(response => {
                this.pagination.rowsNumber = response.data.count

                this.participants = response.data.results.map(e => {
                    return { ...e }
                })
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.loading = false
            })
        },

        fDate(d) {
            if (d) {
                let format = ''

                switch(this.id_user_language_selected) {
                    case 1:
                    case 3: format = 'DD/MM/YYYY HH:mm:ss'
                    break
                    default: format = 'MM-DD-YYYY HH:mm:ss'
                    break
                }

                return date.formatDate(d, format)
            }
        },

        savePagination() {
            this.$store.dispatch('datatable/SET_NUM_ROWS', [this.pagination.rowsPerPage])
        },

        loadPagination() {
            this.pagination.rowsPerPage = this.num_rows
        },

        downloadCertificateReport() {
            let message = this.$t('generating_import_file_message')
            this.$q.loading.show({
                message
            })
            this.$axios.get(`/admin_webcasts/webcasts/${this.id}/webcast_user_results/generate_report_certificate/`, this.getHeader)
            .then(response => {
                this.forceFileDownload(response.data.path_url)
            })
            .catch(e => {
                this.loading = false
                console.log(e)
            })
            .finally(() =>{
                this.$q.loading.hide()
            })
        },

        downloadChatReport() {
            let message = this.$t('generating_import_file_message')
            this.$q.loading.show({
                message
            })
            this.$axios.get(`/admin_webcasts/webcast_chat_report/${this.id}/`, this.getHeader)
            .then(response => {
                this.forceFileDownload(response.data)
            })
            .catch(e => {
                this.loading = false
                console.log(e)
            })
            .finally(() =>{
                this.$q.loading.hide()
            })
        },

        forceFileDownload(response){
			const link = document.createElement('a')
			link.href = response
			document.body.appendChild(link)
			link.click()
        }
    },

    watch: {
        load: function() {
            if (this.load) {
                this.requestParticipants({ pagination: this.pagination })
            }
        },

        num_rows: {
            handler: function(newValue) {
                this.loadPagination()
            },
            deep: true
        }
    },

    created() {
        this.loadPagination()
        this.requestParticipants({ pagination: this.pagination })
    }
}
</script>

<style>

</style>
